import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { MediaState } from 'common/store/genesys-cloud/conversations/messages/models/message-media-state.enum';
import { map, Observable } from 'rxjs';

export interface FileUploadState {
  file: File,
  mediaId: string,
  status: MediaState
}

export const initialState: FileUploadState = {
  file: null,
  mediaId: null,
  status: MediaState.Valid
};

@Injectable()
export class GenesysChatFileUploadStore extends ComponentStore<FileUploadState> {
  constructor() {
    super(initialState);
  }

  readonly fileUploadState$ = this.select(state => state);

  readonly fileUploadSuccess = this.effect((action: Observable<{ mediaId: string, status: MediaState }>) => {
    return action.pipe(
      map(({ mediaId, status }) => this.setMedia(mediaId, status))
    );
  });

  readonly fileUploadFailure = this.effect((action: Observable<void>) => {
    return action.pipe(
      map(() => this.setMediaFailure())
    );
  });

  readonly mediaSent = this.effect((action: Observable<void>) => {
    return action.pipe(
      map(() => this.deleteFile())
    );
  });

  readonly addFile = this.effect((action: Observable<File>) => {
    return action.pipe(
      map(file => this.setFile(file))
    );
  });

  readonly deleteFile = this.effect((action: Observable<void>) => {
    return action.pipe(
      map(() => this.removeFile())
    );
  });

  private setMedia(mediaId: string, status: MediaState): void {
    this.patchState({ mediaId, status });
  }

  private setMediaFailure(): void {
    this.patchState({ status: MediaState.Invalid });
  }

  private setFile(file: File): void {
    this.patchState({ file, mediaId: null, status: MediaState.Uploading });
  }

  private removeFile(): void {
    this.patchState({ file: null, mediaId: null, state: MediaState.Valid });
  }
}

